import { useGetPresentersList } from '@/hooks/presenter';
import { AGENT_DEFAULT_NAME } from '@/pages/agents/constants';
import { getDefaultAgentPresenter } from '@/pages/agents/utils';
import { createAgent } from '@/services/api';
import { getDefaultVoice } from '@/services/presenters/getDefaultVoice';
import { AgentStatus, IAgent, IAgentData, LLM_OPTIONS, Presenter, PresenterUsecase, StreamTextToSpeechVoice, VideoType } from '@d-id/types';
import { useGetAllVoicesFlat } from './useGetAllVoices';

export const useCreateInitialAgent = () => {
    const { data: presenters } = useGetPresentersList({ usecase: PresenterUsecase.Agent });
    const defaultPresenter = getDefaultAgentPresenter(presenters);
    const voices = useGetAllVoicesFlat();

    const createInitialAgent = async (initialPresenter?: Presenter): Promise<IAgent | undefined> => {
        const currentPresenter =
            presenters?.find(({ id }) => id === initialPresenter?.id && !id?.includes('-removed_bg')) ?? defaultPresenter;
        if (!currentPresenter) return;

        const voice = getDefaultVoice(currentPresenter, voices);
        const agentVoice: StreamTextToSpeechVoice | null = voice
            ? {
                  type: voice.provider,
                  voice_id: voice.id,
                  access: voice.access,
                  language: voice.language,
              }
            : null;

        const payload: IAgentData = {
            preview_thumbnail: currentPresenter.thumbnail || currentPresenter.poster,
            preview_name: AGENT_DEFAULT_NAME,
            presenter: {
                ...currentPresenter,
                type: VideoType.CLIP,
                source_url: currentPresenter.thumbnail || currentPresenter.poster,
                presenter_id: currentPresenter.id,
                ...(agentVoice ? { voice: agentVoice } : {}),
            },
            llm: {
                provider: 'openai' as const,
                model: LLM_OPTIONS.GPT_4O_MINI,
            },
            triggers: undefined,
            version: 2,
            status: AgentStatus.Created,
        };

        return createAgent(payload);
    };

    return { createInitialAgent };
};
